import React from "react";
import { Box } from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import AnimatedContainer from "../common/AnimatedContainer";
import WelcomeHeroActions from "./WelcomeHeroActions";
import {
  welcomeHeroCtaOrb1Sx,
  welcomeHeroCtaOrb2Sx,
  welcomeHeroCtaSx
} from "./welcomeSectionStyles";

/** CTA strip below hero — Get Started + download link (mobile and desktop). */
const WelcomeHeroCta: React.FC = () => {
  const { t } = useKivunovaTranslation();

  return (
    <Box
      component="section"
      aria-label={t("welcome-hero-cta-aria", "Get started")}
      data-testid="welcome-hero-cta"
      sx={welcomeHeroCtaSx}
    >
      <Box sx={welcomeHeroCtaOrb1Sx} aria-hidden />
      <Box sx={welcomeHeroCtaOrb2Sx} aria-hidden />
      <Box sx={{ position: "relative", zIndex: 1, width: "100%" }}>
        <AnimatedContainer
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{
            duration: 0.6,
            delay: 0.25,
            ease: [0.25, 0.46, 0.45, 0.94]
          }}
          initial={{ opacity: 0, y: 24, scale: 0.96 }}
        >
          <WelcomeHeroActions />
        </AnimatedContainer>
      </Box>
    </Box>
  );
};

export default WelcomeHeroCta;
